import { Rest } from './rest';

const headers = ({ token }) => ({ Authorization: `Bearer ${token}` });
const Retention = new Rest(process.env.REACT_APP_RETENTION, headers, false);

export default Retention;
